import c from "./index.es517.js";
function n(o) {
  var a = o.schema, r = o.columns;
  if (a || r) {
    var t = (a || r).map(c).join("");
    if (t)
      return "<cols>".concat(t, "</cols>");
  }
  return "";
}
export {
  n as default
};
//# sourceMappingURL=index.es501.js.map
